export * from './time-out.component';
